/**
Misc snippets for improving the UX
*/

(($ => {
    
    // jQuery ready event
    $(document).ready(()=> {
        /**
         * Fit font size in the content blocks
         */
        $('dt', '.events-area').fitText(2, {maxFontSize: '16px' });
        /**
        Remove fouc-protector class when DOM is loaded
        */
        $('.hide-until-dom-loaded').removeClass('hide-until-dom-loaded');
        
        /**
        Autofocus search on input
        */
        $('.search-title input[type=search]').each((ix, el)=> {
            $(el).focus();            
            el.selectionStart = el.selectionEnd = $(el).val().length;
        })

        /**
        Validate registration form
        */
        $("#registration-form form").validate({
             rules: {
                password: "required",
                password_confirm: {
                  equalTo: "#password"
                }
              },
             messages: {
                 firstname: 'Vänligen ange förnamn.',
                 lastname:  'Vänligen ange efternamn.',
                 title: 'Vänligen ange din titel/roll.',
                 email:    'Vänligen ange din e-postadress.',
                 password: 'Vänligen ange ett lösenord.',
                 password_confirm: {
                    required: 'Vänligen bekräfta ditt lösenord',
                    equalTo: "Lösenorden stämmer inte med varandra."
                 }                 
             }
        });
        
    });


}))(jQuery)